import {Button, CloseButton, Form} from "react-bootstrap";
import React, {useEffect, useState} from "react";
import * as utils from "../../utils";
import {SearchSelectFamily} from "./searchSelectFamily";
import {getSisterList} from "../../services/usuario/usuario";

//FORMULARIO DE EDICION DE CARGOS (BOTÓN EDITAR DE CADA DESPLEGABLE)

// Componente del formulario para cada cargo especifico
const ChargeForm = ({charge, sister, ext, ocupados, fieldName, post, submit, getExtern}) => {
    const today = utils.calculateDate();
    // Manejamos los cargos que se muestran en pantalla
    const [forms, setForms] = useState([]);
    // Manejamos que cargos se van a borrar
    const [cargosABorrar, setCargosABorrar] = useState([]);
    const [cargosOcupados, setCargosOcupados] = useState(ocupados);
    const [opciones, setOpciones] = useState([]);

    // forms -> cargos nuevos a postear
    // cargosABorrar -> cargos ya existentes que se quieren eliminar
    // cargosOcupados -> cargos ya existentes que no se han modificado
    // opciones -> externos y hermanas que pueden optar al puesto

    // Fetch de los datos necesarios
    useEffect(
        () => {
            const fn = async () => {
                const promesas = {sister: null, ext: null};
                if (sister) {
                    promesas.sister = getSisterList(null);
                }
                if (ext) {
                    promesas.ext = getExtern(null);
                }
                promesas.sister = promesas.sister ? (await promesas.sister) : [];
                promesas.ext = promesas.ext ? (await promesas.ext) : [];
                const aux = [
                    
                    ...promesas.ext.map(e => ({...e, type: 'ext'})),
                    ...promesas.sister.map(e => ({...e, type: 'sister'})),
                ];
                //cargamos las opciones de hermanas  laicos
                setOpciones(aux)
            };

            fn();
        }, []);

    // Como funciona:
    // Cargamos los cargos ya seleccionados
    // Tenemos 3 listas, una para cargos sin modificar, otra para cargos a subir y otra cargos a borrar
    // Cuando se cambia un cargo ya creado se mueve a la lista a cargos a subir
    // Los cargos nuevos se crean en la lista de cargos a subir

    useEffect(() => {
        if (!submit) {
            return
        }
        //aquí llamamos a x, y para enviar los cargos a cambiar
        const escupe = post(forms, cargosABorrar);
       // console.log( escupe)
    }, [submit]);

    return (
        <>
        {
        //<p><small>AVISO: El encargado/a y la fecha de inicio son obligatorios. La fecha de fin de cargo puede rellenarla ahora o cuando se produzca el cese.</small></p>
        //    Por cada cargo se carga un componente de tipo ChargeForm con sus opciones ya seleccionadas y las añadidas.
        }
           <header className="input-group-text mt-1"><strong>{charge}</strong></header>
            {cargosOcupados.map((f, idx) => (
                <Form.Group>
                    <Form.Label  className="mt-1">Titular responsable *</Form.Label>
                    {
                        opciones &&
                        <SearchSelectFamily
                            optionsOriginal={opciones}
                            defaultValue={f}
                            setOptionParentExt={(id) => {
                                const aux = cargosOcupados[idx];
                                aux.externoId = id;
                                const option = opciones.find(f => f.type === 'ext' && f.id === id)
                                aux.externo = {
                                    name: option.name,
                                    firstSurname: option.firstSurname,
                                    secondSurname: option.secondSurname
                                }
                                aux.sister = null;
                                setForms([aux, ...forms]);
                                setCargosOcupados([...cargosOcupados].splice(1, idx));
                            }}
                            setOptionParentSister={(id) => {
                                const aux = cargosOcupados[idx];
                                aux.sisterId = id;
                                const option = opciones.find(f => f.type === 'sister' && f.id === id)
                                aux.sister = {
                                    user:
                                        {
                                            name: option.name,
                                            firstSurname: option.firstSurname,
                                            secondSurname: option.secondSurname
                                        }
                                }
                                aux.externo = null;
                                setForms([aux, ...forms]);
                                setCargosOcupados([...cargosOcupados].splice(1, idx));
                            }}
                        />
                    }

                    <Form.Label className="mt-2">Fecha de inicio del cargo</Form.Label>
                    <Form.Control type="date" name="startDate" max={today} autoComplete="nope"
                                //required
                                  defaultValue={f.startDate}
                                  onChange={e => {
                                      const aux = cargosOcupados[idx];
                                      aux.startDate = e.target.value;
                                      setForms([aux, ...forms]);
                                      setCargosOcupados([...cargosOcupados].splice(1, idx));
                                  }}/>
                    <Form.Label className="mt-2">Fecha de fin del cargo (si ya expiró)</Form.Label>
                    <Form.Control type="date" name="endDate" max={today} autoComplete="nope"
                                  defaultValue={f.endDate}
                                  onChange={e => {
                                      const aux = cargosOcupados[idx];
                                      aux.endDate = e.target.value;
                                      setForms([aux, ...forms]);
                                      setCargosOcupados([...cargosOcupados].splice(1, idx));
                                  }}/>
                    <Button
                        variant="btn btn-outline-danger"
                        className="mt-2"
                        onClick={() => {
                            setCargosABorrar([...cargosABorrar, ocupados[idx]].filter(c => !!c.id));
                            setCargosOcupados([...cargosOcupados].splice(1, idx));
                        }}>
                        Eliminar cargo
                    </Button>
                  
                </Form.Group>
            ))}
            {
                //
            }
            {forms.map((f, idx) => (
                <Form.Group>
                    <Form.Label className="mt-1">Titular responsable *</Form.Label>
                    {
                        opciones &&
                        <SearchSelectFamily
                            locked = {f.locked}
                            optionsOriginal={opciones}
                            defaultValue={f}
                            setOptionParentExt={(id) => {
                                const auxVec = [...forms];
                                auxVec[idx].externoId = id;
                                const option = opciones.find(f => f.type === 'ext' && f.id === id)
                                auxVec[idx].externo = {
                                    name: option.name,
                                    firstSurname: option.firstSurname,
                                    secondSurname: option.secondSurname
                                }
                                auxVec[idx].sister = null;
                                setForms(auxVec);
                            }}
                            setOptionParentSister={(id) => {
                                const auxVec = [...forms];
                                auxVec[idx].sisterId = id;
                                const option = opciones.find(f => f.type === 'sister' && f.id === id)
                                auxVec[idx].sister = {
                                    user:
                                        {
                                            name: option.name,
                                            firstSurname: option.firstSurname,
                                            secondSurname: option.secondSurname
                                        }
                                }
                                auxVec[idx].externo = null;
                                setForms(auxVec);
                            }}
                        />
                    }
                    <Form.Label className="mt-2">Fecha de inicio del cargo</Form.Label>
                    <Form.Control type="date" name="startDate" max={today} autoComplete="nope"
                                //required
                                defaultValue={f.startDate}
                                onChange={e => {
                                    const aux = [...forms];
                                    aux[idx].startDate = e.target.value;
                                    setForms(aux);
                                }}/>

                    <Form.Label className="mt-2">Fecha de fin del cargo (si ya expiró)</Form.Label>
                    <Form.Control type="date" name="endDate" max={today} autoComplete="nope"
                                  defaultValue={f.endDate}
                                  onChange={e => {
                                      const aux = [...forms];
                                      aux[idx].endDate = e.target.value;
                                      setForms(aux);
                                  }}/>
                    <Button
                        variant="btn btn-outline-danger"
                        className="mt-2"
                        onClick={() => {
                            setCargosABorrar([...cargosABorrar, forms[idx]].filter(c => !!c.id));
                            setForms([...forms].splice(1, idx));
                        }}>
                        Eliminar cargo
                    </Button>
                </Form.Group>
            ))}
   
            <Button
            variant="btn btn-outline-primary"
                className="mt-1 mb-3"
                onClick={() => setForms([...forms, {
                    startDate: null,
                    endDate: null,
                    front: {
                        charge: charge,
                        name: fieldName,
                    },
                    externoId: null,
                    sisterId: null,
                    id: null,
                    locked: true
                    
                }])}>
                Añadir cargo
            </Button>
        </>
    )
};

/* Formulario de edición de cada botón editar de cada desplegable de los TabContent.
    parámetros: 
        field               esquema de cargos a montar en el componente 
        disponiles          array con cargos disponibles
        cargosOcupados      array con cargos ocupados
        post                funcion que hace el post 
        getExtern           funcion que obtiene externos
        coleSeleccionado    colegio con id y nombre para usarlo
        refresca2           recarga el componente superior con los datos actualizados
        handleButtonShow    cierra la modal

*/

export const FormOrganizacion = ({field, disponibles, cargosOcupados, post, getExtern, coleSeleccionado, refresca2 = null, handleButtonShow}) => {
    const [submit, setSubmit] = useState(false);
    

    return (
        
        <Form className=" p-3"
            onSubmit={e => {
                e.preventDefault();
                setSubmit(true);
                setTimeout(() => setSubmit(false), 300);
                //esto es una chapuza para que refresque los cargos en la vista tras en formulario a editar, hay q arreglarlo (de jose)
                refresca2 && setTimeout(() => refresca2(), 300);
                //aqui llamamos a la funcion que cierra el modal pasada por props
                handleButtonShow()
                //alert(coleSeleccionado && coleSeleccionado.nombre)
            }} 
            id="MyForm"
            autoComplete="off">
                <h5 className="mb-3">
                    {coleSeleccionado && coleSeleccionado.nombre +' '} <small><small>(Nota: Los campos con un <b>*</b> deben de ser rellenados.)</small></small>
                </h5>
            {
                field.charges.map(c => <ChargeForm charge={c}
                                                   sister={!!disponibles.cargosHer.find(d => d === c)}
                                                   ext={!!disponibles.cargosExt.find(d => d === c)}
                                                   ocupados={cargosOcupados.filter(f => f.front.charge === c)}
                                                   fieldName={field.name}
                                                   post={post}
                                                   submit={submit}
                                                   getExtern={getExtern}
                />)
                
            }

            <Form.Group>
                <Button type="submit" variant="outline-success" className="btn btn-block mt-5" name="Datos Personals">
                    Guardar
                </Button>
            </Form.Group>
        </Form>
    )
};


